import React, { useMemo, useState } from "react";
import { TableHeader } from "carbon-components-react";
import { TableHeaderDataShape, TableSortFunc } from "web_modules/shared/BaseTable/types";
import { HydratedAction, HydratedSortAction, SortOrderKind } from "./shared";

const styles = require("./styles.module.scss");

type TableHeadersProps = {
  headers: TableHeaderDataShape[];
  getHeaderProps: (unknown) => Record<string, unknown>;
  applySort: TableSortFunc;
  actions: HydratedAction[];
};

type HeaderColumn = {
  header: TableHeaderDataShape;
  applySort: TableSortFunc;
  sortDirection: null | SortOrderKind;
};

// Use the keys as defined in the pipeline schema and map to the desired column width
// packages/operator/web_modules/reporting_dashboard/PipelinePage/helpers.ts
const columnWidthMapping = {
  pinned_message: "250px",
};

const TableHeaderColumn = ({ header, applySort, sortDirection, ...rest }: HeaderColumn) => {
  const columnStyle = columnWidthMapping[header.key]
    ? {
        minWidth: columnWidthMapping[header.key],
      }
    : {};

  const style: any = {
    whiteSpace: "nowrap",
    ...columnStyle,
  };

  const onHeaderClick = key => {
    // the sorting have 3 states null, ascending and descending we must do the 3 options
    // remove the sorting, make it ascendant or descendant
    let sortingType: SortOrderKind = null;

    if (sortDirection !== null) {
      if (sortDirection === SortOrderKind.Ascending) {
        sortingType = SortOrderKind.Descending;
      }
    } else {
      sortingType = SortOrderKind.Ascending;
    }

    applySort(key, sortingType);
  };

  let iconStyles = "";

  if (sortDirection) {
    const headerStyle = `${sortDirection.charAt(0).toUpperCase()}${sortDirection.slice(1)}`;
    iconStyles = styles[`tableHeaderIcon${headerStyle}`];
  }
  return (
    <TableHeader key={header.key} {...rest} style={style}>
      <div className={styles.tableHeaderContainer} onClick={() => onHeaderClick(header.key)}>
        <span>{header.header}</span>
        <div className={`${styles.tableHeaderIcon} ${iconStyles}`}>
          <div className={styles.arrowUp} />
          <div className={styles.arrowDown} />
        </div>
      </div>
    </TableHeader>
  );
};

const TableHeaders = ({ headers, getHeaderProps, applySort, actions }: TableHeadersProps) => {
  return (
    <>
      {useMemo(
        () =>
          headers.map((header: TableHeaderDataShape) => {
            const headerProps = getHeaderProps({ header });
            const sortForColumn = actions.filter(
              a => a.kind === "sort" && a.jsonKey === header.key,
            );
            let sortDirection: SortOrderKind | null = null;
            if (sortForColumn.length > 0) {
              sortDirection = (sortForColumn[0] as HydratedSortAction).sortOrder;
            }
            return (
              <TableHeaderColumn
                header={header}
                {...headerProps}
                applySort={applySort}
                sortDirection={sortDirection}
              />
            );
          }),
        [headers, actions],
      )}
    </>
  );
};

export default TableHeaders;
